import contaServices from '@/api/financialModule/contaServices'

export default {
  findAll({ commit }, pageConfig) {
    return new Promise((resolve, reject) =>
      contaServices
        .findAll(pageConfig)
        .then(result => {
          commit('LOAD_LIST_CONTAS', result.data.content)
          resolve(result)
        })
        .catch(err => reject(err))
    )
  },
  find({ commit }, { nome, pageConfig }) {
    return new Promise((resolve, reject) =>
      contaServices
        .find(nome, pageConfig)
        .then(result => {
          commit('LOAD_LIST_CONTAS', result.data.content)
          resolve(result)
        })
        .catch(err => reject(err))
    )
  },
  findById({ commit }, id) {
    return contaServices.findById(id).then(result => result).catch(error => error)
  },
  insert({ commit }, data) {
    return contaServices.insert(data).then(result => result).catch(error => error)
  },
  update({ commit }, data) {
    return contaServices.update(data).then(result => result).catch(error => error)
  },
  delete({ commit }, id) {
    return contaServices.delete(id).then(result => result).catch(error => error)
  },
  prepareToEdit({ commit }, data) {
    commit('PREPARE_TO_EDIT_CONTA', data)
  },
  reset({ commit }) {
    commit('RESET_CONTA')
  }
}
